import { AcceptedVideoTypes } from '@/utils/getMimeTypeFromFileExtension';

const getExtensionFromFileName = (filename: string): AcceptedVideoTypes | null => {
  const parts = filename.split('.');
  if (parts.length === 1) {
    // No dot in the filename, return null
    return null;
  }
  const extension = parts.pop();
  return (extension as AcceptedVideoTypes) || null;
};

export default getExtensionFromFileName;
